import styled from "styled-components";

const ThumbnailDiv = styled.div`
  margin-left: -12px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  z-index: ${(props) => props.zIndex};
`;

export default ThumbnailDiv;